import sanityClient from '@sanity/client';
import imageUrlBuilder from '@sanity/image-url';

export const client = sanityClient({
  projectId: process.env.REACT_APP_SANITY_PROJECT_ID,
  // projectId: "h16zhmpx",
  dataset: 'production',
  apiVersion: '2022-02-01',
  useCdn: true,
  token: process.env.REACT_APP_SANITY_TOKEN,
  // token: "skT8nfFrdPPwCv4LUQO7kYihCXqmd0GFj3zMaPXH3v1DvFd5g30OrQpg6QztMwYcaMViIR421Cua5uKNk8F68bEY1vZQCm7O85yvsVB81jrV6dwqKxYANOeJ8rFqESrkP5olyHYLUt76pGNgMh3dOUzVLhgCWGaSqWJvUgEfhssMxNH1Mje4",
});

const builder = imageUrlBuilder(client);

export const urlFor = (source) => builder.image(source);
